<template>
  <div class="flex-1 flex-column">
    <div class="auth-bg">
      <p>身份认证</p>
      <svg class="icon" width="60" height="60" viewBox="0,0,120,120">
        <path fill="#fff" d="M60,120 C27,120 0,93 0,60 C0,27 27,0 60,0 C93,0 120,27 120,60 C120,93 93,120 60,120 L60,120 Z M60,3 C28.5,3 3,28.5 3,60 C3,91.5 28.5,117 60,117 C91.5,117 117,91.5 117,60 C117,28.5 91.5,3 60,3 L60,3 Z"></path>
        <path fill="#fff" d="M103.8,98.7 C103.8,98.7 90.6,85.8 72,81 L70.8,80.7 L70.8,79.5 C70.8,79.2 70.8,69.9 73.2,64.8 C73.8,63.6 74.7,62.4 75.6,61.2 C77.7,58.2 80.1,54.6 79.5,52.2 C79.2,51.3 78.9,50.7 77.7,50.4 L76.5,49.8 L77.1,48.6 C77.1,48.6 83.1,35.7 78,27.9 C75,23.4 69,21 60,21 C51,21 45,23.4 42,27.9 C36.9,36 42.9,48.6 42.9,48.6 L43.5,49.8 L42.3,50.4 C41.4,51 40.8,51.6 40.5,52.2 C39.9,54.6 42.3,58.2 44.4,61.2 C45.3,62.4 46.2,63.9 46.8,64.8 C49.2,69.6 49.2,78.9 49.2,79.5 L49.2,80.7 L48,81 C29.4,85.8 16.5,98.4 16.2,98.7 L14.1,96.6 C14.7,96 27.3,83.7 45.9,78.6 C45.9,76.2 45.6,69.9 43.8,66.6 C43.2,65.7 42.6,64.5 41.7,63.3 C39.3,59.7 36.6,55.5 37.5,51.9 C37.8,50.7 38.4,49.8 39.6,48.9 C38.1,45.3 34.5,34.2 39.3,26.4 C42.9,21 49.8,18 59.7,18 C69.9,18 76.8,20.7 80.1,26.4 C85.2,34.2 81.3,45.3 79.8,48.9 C80.7,49.8 81.6,50.7 81.9,51.9 C82.8,55.5 80.1,59.7 77.7,63.3 C76.8,64.5 76.2,65.7 75.6,66.6 C73.8,69.9 73.8,76.2 73.5,78.6 C92.1,83.7 105,96 105.3,96.6 L103.8,98.7 L103.8,98.7 Z"></path>
      </svg>
    </div>
    <div class="container">
      <u-tabs :value="$route.path" @change="v=>$router.push(v)">
        <u-tab label="登录" value="/auth/login">
          <login></login>
        </u-tab>
        <u-tab label="注册" value="/auth/register">
          <register></register>
        </u-tab>
      </u-tabs>
      <u-button type="text" style="margin-top:40px;">忘记密码？</u-button>
    </div>
  </div>
</template>
<script>
import Login from './Login.vue'
import Register from './Register.vue'
export default {
  components: {
    Login, Register
  }
}
</script>
<style lang="stylus" scoped>
@import "../../components/var.styl"
.auth-bg
  position relative
  height 150px
  margin-bottom 20px
  background linear-gradient(to right top, lighten($color-primary,8%), darken($color-primary, 8%))
  > p
    position absolute
    bottom 16px
    width 100%
    margin 0 auto
    color #fff
    font-size 16px
    text-align center
.icon
  position absolute
  left 50%
  bottom 40px
  margin-left -30px
</style>



// WEBPACK FOOTER //
// Auth.vue?37a1fc00